// @flow

import {createBrowserHistory} from 'history';

/**
 * @deprecated It will be removed in 6 months 09-12-2025. Use instead methods from react-router-dom(react-router).
 * */
export const browserHistory: $Call<typeof createBrowserHistory> = createBrowserHistory();
